import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";

import { IoFlameOutline } from "react-icons/io5";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Col, InputGroup, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { useWorkout } from "../hooks/workoutHook";
import CardExerciseCompleted from "../components/CardExerciseCompleted";
import { PALETTE } from "../../common/ThemeConstants";
import { getRequest, postRequest } from "../../api/axiosRequests";
import WorkoutHeader from "../components/WorkoutHeader";
import ContainerResponsive from "../../common/components/ContainerResponsive";
import { usePlan } from "../../plan/hooks/planHook";

export default function WorkoutCompleted() {
  const workoutContext = useWorkout();
  const planContext = usePlan();
  const workout = workoutContext.workoutData.workout;
  const [maximumUserExercises, setMaximumUserExercises] = useState([]);
  // const [userExercises, setUserExercises] = useState([]);
  const [updateRM, setUpdateRM] = useState(false);
  const [fatigueLevel, setFatigueLevel] = useState(5);
  const navigate = useNavigate();

  const updateUserExercisesMaximum = (idExercise, weight) => {
    setMaximumUserExercises(
      maximumUserExercises.map((el) =>
        el.id === idExercise ? { ...el, weight: weight } : el
      )
    );
  };

  const getUserExerciseWeight = (idExercise) => {
    const userExercise = maximumUserExercises.filter(
      (el) => el.id === idExercise
    )[0];
    if (userExercise) {
      return userExercise.weight;
    }

    return "0";
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const csrftoken = Cookies.get("csrftoken");
    const headers = {
      Authorization: localStorage.getItem("jwt"),
      "X-CSRFToken": csrftoken,
    };
    const userPlanDayCompletedData = {
      planDay: workoutContext.workoutData.idPlanDay,
      fatigueLevel: fatigueLevel,
    };
    const promises = [
      postRequest(
        "updateUserPlanDayCompleted/",
        userPlanDayCompletedData,
        headers
      ),
    ];
    if (updateRM) {
      maximumUserExercises.map((maximumUserExercise) => {
        const rmData = {
          id: maximumUserExercise.idRMUserExercise,
          exercise: maximumUserExercise.id,
          user: maximumUserExercise.userId,
          maximumWeight: parseInt(maximumUserExercise.weight),
          favourite: maximumUserExercise.favourite,
        };
        promises.push(
          postRequest("updateUserExerciseMaximum/", rmData, headers)
        );
        return null;
      });
    }

    Promise.all(promises)
      .then((values) => {
        // Remove all the completed exercises related to the workout from the local storage
        let completedExercises = localStorage.getItem("completedExercises");
        const idPlanDay = workoutContext.workoutData.idPlanDay;
        if (completedExercises) {
          completedExercises = completedExercises.split(",");
          completedExercises = completedExercises.filter(
            (el) => !el.match(idPlanDay + "-" + workout.id + "-[0-9]-[0-9]")
          );
          localStorage.setItem("completedExercises", completedExercises.join(","));
        }

        // Redirect to the workout content page
        navigate(`/workout/${planContext.planData.id}/Content`);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getExerciseRMData = (exercisesRMList, exerciseId) => {
    let weight = 0;
    let favourite = false;
    let id = -1;
    exercisesRMList.forEach((element) => {
      if (element.exercise === exerciseId) {
        weight = element.maximumWeight;
        id = element.id;
        favourite = element.favourite;
      }
    });
    return { id: id, weight: weight, favourite: favourite };
  };

  useEffect(() => {
    let userExercisesData = [];
    let userExercisesAll = [];

    const headers = { Authorization: localStorage.getItem("jwt") };
    const promiseUserData = getRequest("userData/", headers);
    promiseUserData
      .then((res) => {
        const userId = res["data"]["data"].id;
        const promise = getRequest(
          "userExerciseMaximumForUser/" + userId,
          headers
        );
        promise
          .then((data) => {
            const userExercisesRMData = data.data;
            workout.superseries.map((superserie) => {
              superserie.exercises.map((exercise) => {
                userExercisesAll.push({
                  workoutExercise: exercise.idWorkoutExercise,
                  weight: exercise.weight,
                });
                if (!exercise.relatedExerciseMaximum && exercise.primary) {
                  const rmData = getExerciseRMData(
                    userExercisesRMData,
                    exercise.id
                  );
                  const userExercise = {
                    id: exercise.id,
                    idWorkoutExercise: exercise.idWorkoutExercise,
                    userId: userId,
                    name: exercise.name,
                    cover: exercise.cover,
                    weight: rmData["weight"],
                    idRMUserExercise: rmData["id"],
                    favourite: rmData["favourite"],
                  };
                  userExercisesData.push(userExercise);
                }
                return null;
              });
              return null;
            });
            let filtered = [];
            userExercisesData.forEach((userEx) => {
              const found = filtered.filter((el) => el.id === userEx.id);
              if (found.length === 0) {
                filtered.push(userEx);
              }
            });
            // setUserExercises(userExercisesAll);
            setMaximumUserExercises(filtered);
          })
          .catch((err) => { });
      })
      .catch((err) => { });
  }, [workout.superseries]);

  return (
    <>
      <WorkoutHeader
        title={workout.name}
        showInfo={false}
        showCompleted={true}
      />
      <ContainerResponsive>
        <Container className="text-center my-3">
          <h2
            className="rounded-sm "
            style={{
              color: PALETTE.SECONDARYCOLOR,
              fontWeight: 'bold',
              padding: '15px',
              background: PALETTE.GRADIENTLIGHT,
            }}
          >
            Congratulazioni per aver completato il workout!
          </h2>
        </Container>
        <Container className="my-3">
          <div className="rounded-sm p-3" style={{ background: PALETTE.WHITE }}>
            <Row className="m-auto" style={{ width: "100%" }}>
              <Col xs={10} className="text-start px-0">
                <p
                  className="mb-0"
                  style={{
                    color: PALETTE.SECONDARYCOLOR,
                    fontWeight: 'bold',
                  }}
                > <IoFlameOutline className="me-1 mb-1" />
                  Livello di fatica dell'allenamento
                </p>
                <p className="mb-0 ms-1" style={{ fontSize: 12, color: PALETTE.GRAY }}>
                  0 - Nessuna fatica, 10 - Molta fatica
                </p>
              </Col>
              <Col xs={2} className="text-end px-0">
                <div className="p-2 text-center rounded-sm" style={{
                  background: PALETTE.GRADIENTLIGHT,
                  width: '45px',
                  fontWeight: 'bold',
                  display: 'inline-block'
                }}>
                  {fatigueLevel}
                </div>
              </Col>
            </Row>

            <div className="d-flex flex-column align-items-center">
              <div className="w-100 position-relative my-2">
                {/* Gradient background track */}
                <div
                  className="position-absolute w-100"
                  style={{
                    height: '6px',
                    borderRadius: '3px',
                    background: 'linear-gradient(to right, #e0e0e0, #724ab0)',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    zIndex: 0
                  }}
                ></div>

                {/* Custom styled range input */}
                <Form.Range
                  id="fatigue-level-range"
                  min={0}
                  max={10}
                  step={1}
                  value={fatigueLevel}
                  onChange={(e) => setFatigueLevel(parseInt(e.target.value))}
                  className="w-100 position-relative"
                  style={{
                    zIndex: 1,
                    background: 'transparent',
                    '--range-progress': `${fatigueLevel * 10}%`
                  }}
                />

                {/* Value indicators */}
                <div className="d-flex justify-content-between w-100 mt-1 px-2">
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((value) => (
                    <div
                      key={value}
                      className="position-relative"
                      style={{
                        width: '2px',
                        height: '10px',
                        opacity: value <= fatigueLevel ? 1 : 0.3,
                        background: value <= fatigueLevel
                          ? `rgba(114, 74, 176, ${0.3 + (value / 10) * 0.7})`
                          : '#e0e0e0'
                      }}
                    >
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </Container>
        <Container className="mt-2" style={{ paddingBottom: 80 }}>
          <div className="rounded-sm" style={{ background: PALETTE.WHITE }}>
            <Form className="p-3">
              <InputGroup className="align-self-center" style={{ width: "100%" }}>
                <Row className="m-auto" style={{ width: "100%" }}>
                  <Col xs={10} className="text-start px-0">
                    <p className="mb-0" style={{ fontWeight: "bold", color: PALETTE.DARK }}>
                      Aggiorna i massimali
                    </p>
                    <p className="mb-0" style={{ fontSize: 12, color: PALETTE.GRAY }}>
                      Aggiornare i massimali degli esercizi completati.
                    </p>
                  </Col>
                  <Col xs={2} className="text-end px-0">
                    <Form.Check
                      type="switch"
                      id="custom-switch"
                      className="custom-check-label"
                      checked={updateRM}
                      isValid
                      onChange={(event) => {
                        setUpdateRM(event.target.checked);
                      }}
                    />
                  </Col>
                </Row>
              </InputGroup>
              {updateRM &&
                maximumUserExercises.map((exercise) => (
                  <div key={exercise.id} className="mb-2">
                    <CardExerciseCompleted
                      onWeightChanged={updateUserExercisesMaximum}
                      weightValue={getUserExerciseWeight(exercise.id)}
                      exercise={exercise}
                    />
                  </div>
                ))}
            </Form>
          </div>
        </Container>
        <div
          className="m-auto px-2"
          style={{ width: "100%", bottom: 40, position: "fixed" }}
        >
          <Container style={{ background: PALETTE.LIGHTGRAY }}>
            <Button
              size="lg"
              className="shadow"
              style={{
                width: "100%",
                color: PALETTE.LIGHTGRAY,
                background: `
                  linear-gradient(217deg, rgb(39, 37, 155, .7), rgb(39, 37, 155, .0) 70.71%),
                  linear-gradient(127deg, rgb(225, 105, 25, .7), rgb(255, 105, 25, .0) 70.71%),
                  linear-gradient(336deg, rgb(184, 42, 139, .7), rgb(184, 42, 139, .0) 70.71%)
                `,
                border: `0px solid ${PALETTE.SECONDARYCOLOR}`,
                borderRadius: "20px",
              }}
              onClick={handleSubmit}
            >
              Salva
            </Button>
          </Container>
        </div>
      </ContainerResponsive>
    </>
  );
}
